import { ALL_SPRITE_NAMES, TILE_H, TILE_W } from './mapUtils';

export interface Sprites {
  images: Map<string, HTMLImageElement>;
  /** Durchschnittsfarbe je Sprite [r, g, b] -- Grundlage der Übersichtsansicht. */
  averageColor: Map<string, [number, number, number]>;
}

function loadImage(name: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Sprite "${name}" konnte nicht geladen werden.`));
    image.src = `/ag-planer/map/${name}.png`;
  });
}

function averageOf(image: HTMLImageElement): [number, number, number] {
  const canvas = document.createElement('canvas');
  canvas.width = TILE_W;
  canvas.height = TILE_H;
  const ctx = canvas.getContext('2d', { willReadFrequently: true })!;
  ctx.drawImage(image, 0, 0);
  const { data } = ctx.getImageData(0, 0, TILE_W, TILE_H);
  let r = 0;
  let g = 0;
  let b = 0;
  const pixels = data.length / 4;
  for (let i = 0; i < data.length; i += 4) {
    r += data[i]!;
    g += data[i + 1]!;
    b += data[i + 2]!;
  }
  return [Math.round(r / pixels), Math.round(g / pixels), Math.round(b / pixels)];
}

let cached: Promise<Sprites> | null = null;

/** Lädt alle Kartensprites genau einmal je Seitenaufruf (die Dateien liegen unter /ag-planer/map/, aus dem Spiel übernommen). */
export function loadSprites(): Promise<Sprites> {
  cached ??= Promise.all(ALL_SPRITE_NAMES.map(async (name) => [name, await loadImage(name)] as const)).then((entries) => {
    const images = new Map(entries);
    const averageColor = new Map<string, [number, number, number]>();
    for (const [name, image] of images) averageColor.set(name, averageOf(image));
    return { images, averageColor };
  });
  cached.catch(() => {
    cached = null;
  });
  return cached;
}
